













































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
@Component({
    components: {},
})
export default class Forget extends AbpBase {
    viewModel = {
        phoneNumber: "",
        resetCode: "",
        password: "",
    };

    getCode: string | number = "获取验证码";
    isGeting = false;
    count = 6;
    disable = false;
    spinShow = false;
    disabled:boolean=false;
    content:string="获取验证码";

    getVerifyCode() {
        if (this.viewModel.phoneNumber == "") {
            this.$Modal.error({
                title: "提示信息",
                content: "请输入手机号",
            });
            return;
        }
        if (
            !/(^1[3456789]\d{9}$)|(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,6})?$)/.test(
                this.viewModel.phoneNumber
            )
        ) {
            this.$Modal.error({
                title: "提示信息",
                content: "号码格式不正确",
            });
            return;
        }

        let countDown: any = null;
        Ajax.post("/api/services/app/Account/SendPasswordResetCode", {
            phoneNumber: this.viewModel.phoneNumber,
        }).then((res) => {
         this.cutDown();
            //     clearInterval(countDown);
            //     this.isGeting = false;
            //     this.disable = false;
            //     this.getCode = "获取验证码";
            //     this.count = 6;
            // }
        });
        
        // countDown = setInterval(()=>{
        //     if (this.count < 1) {
        //         this.isGeting = false;
        //         this.disable = false;
        //         this.getCode = '获取验证码';
        //         this.count = 6;
        //         clearInterval(countDown);
        //     } else {
        //         this.isGeting = true;
        //         this.disable = true;
        //         this.getCode = this.count-- + 's后重发';
        //     }
        // },1000);
    }
       cutDown () {
            //倒计时
            let time = 60;
            let timer = setInterval(() => {
                if (time == 0) {
                    clearInterval(timer);
                    this.disabled = false;
                    this.content = "获取验证码";
                } else {
                    this.content = time + '秒后重试';
                    this.disabled = true;
                    time--
                }
            }, 1000)
        }
    async save() {
        if (this.viewModel.phoneNumber == "") {
            this.$Modal.error({
                title: "提示信息",
                content: "请输入手机号",
            });
            return;
        }
        if (
            !/(^1[3456789]\d{9}$)|(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,6})?$)/.test(
                this.viewModel.phoneNumber
            )
        ) {
            this.$Modal.error({
                title: "提示信息",
                content: "号码格式不正确",
            });
            return;
        }
        if (this.viewModel.resetCode == "") {
            this.$Modal.error({
                title: "提示信息",
                content: "请输入验证码",
            });
            return;
        }
        if (this.viewModel.password == "") {
            this.$Modal.error({
                title: "提示信息",
                content: "请输入密码",
            });
            return;
        }
        this.spinShow = true;
        await Ajax.post(
            "/api/services/app/Account/ResetPassword",
            this.viewModel
        );
        this.spinShow = false;
        (this.$refs.forgetForm as any).resetFields();
    }
    mounted() {
        let domHtml = document.querySelector("html");
        domHtml.style.height = "100%";
        domHtml.style.width = "100%";
        let domBody = document.querySelector("body");
        domBody.style.height = "100%";
        domBody.style.width = "100%";
        let domApp = document.getElementById("app");
        domApp.style.height = "100%";
    }
    rules = {
        phoneNumber: [
            {
                required: true,
                message: "请输入手机号",
                trigger: "blur",
            },
            {
                pattern:
                    /(^1[3456789]\d{9}$)|(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,6})?$)/,
                message: this.L(
                    "IncorrectFormat",
                    undefined,
                    this.L("PhoneNumber")
                ),
                trigger: "blur",
            },
        ],
        resetCode: [
            {
                required: true,
                message: "请输入验证码",
                trigger: "blur",
            },
        ],
        password: [
            {
                required: true,
                message: "请输入密码",
                trigger: "blur",
            },
        ],
    };
}
